import { render, staticRenderFns } from "./PastEventCard.vue?vue&type=template&id=200c16f8&scoped=true&"
import script from "./PastEventCard.vue?vue&type=script&lang=js&"
export * from "./PastEventCard.vue?vue&type=script&lang=js&"
import style0 from "./PastEventCard.vue?vue&type=style&index=0&id=200c16f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200c16f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VChip,VImg})
